import { render, staticRenderFns } from "./CourseEditDialog.vue?vue&type=template&id=972607b6&scoped=true&"
import script from "./CourseEditDialog.vue?vue&type=script&lang=js&"
export * from "./CourseEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseEditDialog.vue?vue&type=style&index=0&id=972607b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972607b6",
  null
  
)

export default component.exports